// Función para calcular distancia entre dos coordenadas
export function getDistance(lat1, lng1, lat2, lng2) {
  function toRad(x) { return x * Math.PI / 180; }
  const R = 6371; // Radio de la tierra en km
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) * Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}

// Función para obtener la dirección más cercana
export function getDireccionMasCercana(addressClient, posicionActual) {
  if (!posicionActual || !addressClient || addressClient.length === 0) return [];

  // Calcular distancias y guardar en cada objeto
  const addressesWithDistance = addressClient.map(addr => {
    if (addr.lat && addr.lng) {
      const dist = getDistance(
        posicionActual.lat,
        posicionActual.lng,
        parseFloat(addr.lat),
        parseFloat(addr.lng)
      );
      return {
        ...addr,
        distancia_km: dist,
        distancia_m: Math.round(dist * 1000),
        closest: false
      };
    }
    return { ...addr, distancia_km: null, distancia_m: null, closest: false };
  });

  // Encontrar el índice del más cercano
  let minIndex = -1;
  let minDist = Infinity;
  addressesWithDistance.forEach((addr, idx) => {
    if (addr.distancia_km !== null && addr.distancia_km < minDist) {
      minDist = addr.distancia_km;
      minIndex = idx;
    }
  });

  // Marcar el más cercano
  if (minIndex !== -1) {
    addressesWithDistance[minIndex].closest = true;
  }

  return addressesWithDistance;
}